import { Reducer } from 'redux';
import { v4 as createUUID } from 'uuid';
import { ProcessStepCodesEnum } from 'app/features/Service/QueryPolicy/Modify/types';
import { ModifyState, ModifyActions, SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL_DONE, SERVICE_QUERY_POLICY_MODIFY__SET_ACCESSIBLE_STEP, SERVICE_QUERY_POLICY_MODIFY__SAVE_POLICY_INFO_PAGE_DATA, SERVICE_QUERY_POLICY_MODIFY__SEND_OTP_DONE, SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP_DONE, SERVICE_QUERY_POLICY_MODIFY__UPDATE_CACHE, SERVICE_QUERY_POLICY_MODIFY__RESET_CACHE, SERVICE_QUERY_POLICY_MODIFY__SAVE_MODIFY_REQ, SERVICE_QUERY_POLICY_MODIFY__SAVE_TRANS_ID } from './types';

const initialState: ModifyState = {
  static: {},
  process: {
    accessibleSteps: [],
    policyInfo: {},
    confirmInfo: {
      otpAuth: {}
    }
  }
};

const modifyRducer: Reducer<ModifyState, ModifyActions> = (state = initialState, action): ModifyState => {
  switch (action.type) {
    // 取得保單明細 完成
    case SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL_DONE: {
      // 說明：取得保單明細完成後會導頁至「改期流程」，因此將修改保期 (Step-1-1) 設為可訪問步驟。
      const accessibleSteps = [ProcessStepCodesEnum.PolicyInfo];
      return { ...state, static: { ...state.static, detail: action.payload.response, paymentWSUUID: createUUID() }, process: { ...state.process, accessibleSteps } };
    }
    // 設置可訪問步驟
    case SERVICE_QUERY_POLICY_MODIFY__SET_ACCESSIBLE_STEP: {
      const currentStep = action.payload.step;
      const accessibleSteps = state.process.accessibleSteps.filter((step) => step !== currentStep).concat(currentStep);
      return { ...state, process: { ...state.process, accessibleSteps } };
    }
    // 緩存「修改保期」(Step-1) 資料
    case SERVICE_QUERY_POLICY_MODIFY__SAVE_POLICY_INFO_PAGE_DATA: {
      return { ...state, process: { ...state.process, policyInfo: { ...state.process.policyInfo, data: action.payload.data } } };
    }
    // 發送 OTP 驗證碼 完成
    // 重新發送 OTP 驗證碼 完成
    case SERVICE_QUERY_POLICY_MODIFY__SEND_OTP_DONE:
    case SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP_DONE: {
      return { ...state, process: { ...state.process, confirmInfo: { ...state.process.confirmInfo, otpAuth: { ...state.process.confirmInfo.otpAuth, otp: action.payload.response } } } };
    }
    // 更新流程資料緩存
    case SERVICE_QUERY_POLICY_MODIFY__UPDATE_CACHE: {
      return { ...action.payload.cache };
    }
    // 重置資料緩存
    case SERVICE_QUERY_POLICY_MODIFY__RESET_CACHE: {
      return { ...initialState };
    }
    // 緩存 IR#017 上行電文
    case SERVICE_QUERY_POLICY_MODIFY__SAVE_MODIFY_REQ: {
      return { ...state, modifyPolicyPeriodArgs: action.payload.args };
    }
    // 緩存交易序號
    case SERVICE_QUERY_POLICY_MODIFY__SAVE_TRANS_ID: {
      return { ...state, transId: action.payload.transId };
    }
    // Default
    default:
      return state;
  }
};

export default modifyRducer;
